import React from 'react'
import { Button } from '@mui/material'
import * as yup from 'yup'
import {
	File as FileProps,
	UserLoanTask,
} from '@matech/thebigpos-sdk'
import {
	DropzoneField,
	Form,
	FormRow,
} from '../../../../components/formControls'
import useForm from '../../../../hooks/useForm'
import { LoadingBtn } from '../../../../components/Button'
import { fileMBSizes } from '../../../../services/utils'
import { useSiteConfig } from '../../../../hooks'

export type LoanTaskDocumentFormFieldValues = {
	documents: FileProps[]
}

export type LoanTaskDocumentFormProps = {
	loanTask?: UserLoanTask
	onSubmit: (data: { documents: FileProps[] }) => void
	onCancel?: () => void
	initialValues?: LoanTaskDocumentFormFieldValues
}

const LoanTaskDocumentForm = ({
	loanTask,
	onSubmit,
	onCancel = undefined,
	initialValues,
}: LoanTaskDocumentFormProps) => {
	const { siteConfig } = useSiteConfig()

	const schema = yup.object().shape({
		documents: yup
			.array()
			.min(1)
			.required('At least 1 document is required'),
	})

	const form = useForm<LoanTaskDocumentFormFieldValues>({
		defaultValues: initialValues,
		schema,
	})

	const {
		handleSubmit,
		formState: { errors, isSubmitting },
		control,
	} = form

	const renameParts = (function getRenameParts() {
		if (
			!loanTask ||
			!siteConfig?.enabledServices?.autoNameTaskDocuments
		) {
			return undefined
		}
		const { task, user } = loanTask
		return [`${user.firstName}-${user.lastName}`, task.name]
	})()

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<FormRow>
				<DropzoneField
					name="documents"
					accept={{
						'': [
							'image/jpeg',
							'image/png',
							'image/gif',
							'image/webp',
							'.pdf',
							'.doc',
							'.docx',
							'.rtf',
						],
					}}
					helperText="Upload PDF, Image (.jpeg .png) or Document (.doc .docx .rtf) files"
					control={control}
					errors={errors}
					minSize={0}
					maxSize={fileMBSizes[20]}
					maxFiles={10}
					renameParts={renameParts}
				/>
			</FormRow>
			<FormRow className="flex flex-row justify-between items-center mt-6">
				{onCancel && (
					<div className="mr-2">
						<Button id="Cancel" onClick={onCancel} variant="outlined">
							Cancel
						</Button>
					</div>
				)}
				<LoadingBtn
					disabled={isSubmitting}
					loading={isSubmitting}
					type="submit"
					text="Save"
					fullWidth={false}
				/>
			</FormRow>
		</Form>
	)
}

export default LoanTaskDocumentForm
